import { render, staticRenderFns } from "./ListAuditoriaObservacaoView.vue?vue&type=template&id=acf3ee80&"
import script from "./ListAuditoriaObservacaoView.vue?vue&type=script&lang=ts&"
export * from "./ListAuditoriaObservacaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports